
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialKeyword from './TestimonialKeyword';
import FAQKeyword from './FAQKeyword';
import Testimonials from './TestimonialKeyword';

function Busserviceinpune() {



    const cardData =
    {
        keyword: 'Bus Services in Pune',
        heading: 'S9 Travels: Bus Services in Pune',
        headingDescription: 'S9 Travels offers convenient, comfortable, and affordable bus services in Pune for various purposes, including city tours, corporate transportation, group travel, and more. Whether you are planning a group outing, a corporate event, or a family trip, our buses are equipped with modern amenities to ensure a smooth and comfortable journey. With a focus on safety, punctuality, and customer satisfaction, we guarantee a hassle-free experience for all your travel needs.',

        top: 'Types of Bus Services Offered by S9 Travels in Pune:',

        "topPlaces": [
            {
              "title": "Local City Tours",
              "description": "Explore the vibrant city of Pune with our local city tour bus services. Visit popular attractions like Shaniwar Wada, Aga Khan Palace, Osho Ashram, Sinhagad Fort, and more with a comfortable and guided tour."
            },
            {
              "title": "Outstation Bus Services",
              "description": "For group trips to popular outstation destinations, we offer affordable and reliable bus services from Pune to nearby places such as Lonavala, Mahabaleshwar, Shirdi, Alibaug, and Goa. Perfect for family vacations, corporate outings, or group tours."
            },
            {
              "title": "Corporate Travel",
              "description": "S9 Travels provides corporate bus services for employee commutes, conferences, seminars, and team-building events. Our buses are equipped with amenities such as air conditioning, comfortable seating, and Wi-Fi for a pleasant travel experience."
            },
            {
              "title": "Private Group Bookings",
              "description": "If you're traveling with a large group, we offer private bus rentals for weddings, family reunions, educational trips, or any other group events. You can choose from different bus sizes to suit the number of passengers in your group."
            },
            {
              "title": "Wedding & Event Transport",
              "description": "Ensure your guests have a smooth and comfortable journey with our wedding and event bus services. We offer buses that can accommodate large groups, ensuring that everyone arrives together and on time."
            },
            {
              "title": "Airport Transfers",
              "description": "We offer reliable and comfortable airport transfer services, ensuring you and your group reach Pune International Airport or your destination with ease and convenience."
            },
            {
              "title": "Tourist Bus Services",
              "description": "For tourists visiting Pune and nearby regions, we offer guided tourist bus services to explore historical landmarks, scenic spots, and other attractions. Our buses are designed to provide maximum comfort for long-distance trips."
            }
          ],

"services": [
    {
      "name": "Pune Bus Services",
      "description": "S9 Travels offers a range of reliable and comfortable bus services in Pune. Whether you're traveling within the city, for tours, or need a private hire, we ensure a safe and convenient journey with professional drivers and well-maintained buses."
    },
    {
      "name": "Pune Local Bus Service",
      "description": "Our Pune local bus services provide affordable and convenient travel options for residents and visitors. Whether you're commuting within the city or heading to a nearby destination, S9 Travels offers reliable local bus services to meet your needs."
    },
    {
      "name": "Pune Private Bus Hire",
      "description": "Looking for a private bus for your group or event in Pune? S9 Travels provides flexible private bus hire services to cater to various needs, whether for corporate events, weddings, family outings, or other group trips. Book your private bus today!"
    },
    {
      "name": "Pune Bus Booking",
      "description": "Booking a bus in Pune is easy with S9 Travels. Whether you need a bus for local travel, outstation trips, or group tours, we offer a seamless booking process to ensure your journey is comfortable and hassle-free."
    },
    {
      "name": "Pune Bus Rentals",
      "description": "S9 Travels offers affordable and flexible bus rental services in Pune. Choose from a range of buses, from standard to luxury, for your group travel needs. We ensure a smooth and enjoyable ride with professional drivers at competitive prices."
    },
    {
      "name": "Pune Bus Taxi Services",
      "description": "Looking for a bus taxi service for your group travel in Pune? S9 Travels offers reliable and efficient bus taxi services, providing a comfortable journey with a wide range of buses to suit your requirements."
    },
    {
      "name": "Pune Bus Route",
      "description": "S9 Travels provides well-planned and reliable bus routes for both local and outstation travel in Pune. Whether you are looking to visit specific tourist spots or commute for daily tasks, we have various routes to meet your needs."
    },
    {
      "name": "Bus Service for Tours in Pune",
      "description": "Explore Pune and nearby attractions with our bus service for tours. S9 Travels offers comfortable and convenient buses for city sightseeing, day tours, and customized packages to ensure you enjoy every moment of your trip."
    },
    {
      "name": "Pune City Bus",
      "description": "S9 Travels offers efficient city bus services in Pune, designed for both residents and tourists. Whether you're traveling to popular spots or commuting across the city, our city bus services are a great option for convenient travel."
    },
    {
      "name": "Pune Luxury Bus Service",
      "description": "For those who want to travel in style, S9 Travels offers luxury bus services. Whether it’s for a special event or an elite corporate trip, our luxury buses provide maximum comfort, space, and top-tier amenities for a premium travel experience."
    },
    {
      "name": "Pune to Mumbai Bus Booking",
      "description": "S9 Travels offers reliable and comfortable bus services from Pune to Mumbai. Whether you are traveling for business or leisure, our buses provide a smooth and affordable ride with various booking options available."
    },
    {
      "name": "Pune Group Bus Hire",
      "description": "Planning a group trip? S9 Travels offers group bus hire services from Pune for large gatherings, family outings, corporate events, or school trips. Our spacious buses ensure that everyone travels comfortably and arrives together."
    },
    {
      "name": "Pune Bus Fare",
      "description": "S9 Travels offers competitive and transparent bus fares for all our services in Pune. Whether it’s a local bus ride or an outstation trip, you can trust us to provide fair pricing with no hidden charges. Contact us for fare details and bookings."
    },
    {
      "name": "Pune School Bus Service",
      "description": "For school trips or daily transportation needs, S9 Travels provides reliable school bus services in Pune. Our buses are safe, well-maintained, and driven by experienced professionals to ensure the safety and comfort of students."
    },
    {
      "name": "Pune Sightseeing Bus",
      "description": "Explore Pune and nearby tourist attractions with our sightseeing bus services. S9 Travels offers convenient buses for city tours, allowing you to visit popular destinations like historical monuments, temples, and parks in comfort."
    }
  ],


"tableData": [
  ["Pune Bus Services", "Pune Local Bus Service"],
  ["Pune Private Bus Hire", "Pune Bus Booking"],
  ["Pune Bus Rentals", "Pune Bus Taxi Services"],
  ["Pune Bus Route", "Bus Service for Tours in Pune"],
  ["Pune City Bus", "Pune Luxury Bus Service"],
  ["Pune to Mumbai Bus Booking", "Pune Group Bus Hire"],
  ["Pune Bus Fare", "Pune School Bus Service"],
  ["Pune Sightseeing Bus", ""]
],
"whychoose": [
  {
    "WhyChooseheading": "Reliable and On-Time Service",
    "WhyChoosedescription": "At S9 Travels, we understand the importance of punctuality. Whether you're traveling for a corporate event, a family trip, or a group outing, our buses are always on time. We ensure smooth and timely transportation, so you can focus on enjoying your trip."
  },
  {
    "WhyChooseheading": "Comfortable and Spacious Buses",
    "WhyChoosedescription": "We offer a range of well-maintained and comfortable buses for all your transportation needs in Pune. From air-conditioned buses to spacious seating arrangements, we ensure that your journey is as comfortable as possible."
  },
  {
    "WhyChooseheading": "Experienced and Professional Drivers",
    "WhyChoosedescription": "Our professional and experienced drivers are trained to handle group travel, ensuring a safe and smooth ride. They are familiar with the best routes and always prioritize passenger safety and comfort."
  },
  {
    "WhyChooseheading": "Affordable and Transparent Pricing",
    "WhyChoosedescription": "S9 Travels offers competitive and transparent pricing for bus services in Pune. We provide clear pricing upfront with no hidden charges, so you know exactly what to expect."
  },
  {
    "WhyChooseheading": "Safety and Security",
    "WhyChoosedescription": "The safety of our passengers is our top priority. Our buses are equipped with modern safety features such as seat belts, first aid kits, and GPS tracking, ensuring a secure and safe journey for everyone."
  },
  {
    "WhyChooseheading": "24/7 Availability",
    "WhyChoosedescription": "We offer bus services around the clock, whether you need transportation for a morning event, a late-night journey, or a weekend outing. Our customer service team is available 24/7 to help with bookings and inquiries."
  },
  {
    "WhyChooseheading": "Flexible Booking Process",
    "WhyChoosedescription": "Booking your bus service with S9 Travels is quick and easy. You can book online via our website or app, or contact our customer service team for personalized assistance."
  },
  {
    "WhyChooseheading": "Customized Group Travel Packages",
    "WhyChoosedescription": "We understand that every group has different needs. Whether it's for a corporate trip, a school excursion, or a family gathering, we offer customized travel packages designed to meet your specific requirements."
  }
]




















    }



    const faqData = [
        [
          {
            question: 'How can I book a bus service in Pune with S9 Travels?',
            answer: 'Booking is easy! You can book online through our website or app, or you can call our customer service team for assistance with your booking.',
          },
          {
            question: 'What types of buses are available for service in Pune?',
            answer: 'We offer a range of buses, including mini-buses and large coaches, all well-maintained for comfort and convenience. Our fleet is equipped with air-conditioning, comfortable seating, and ample space for luggage.',
          },
          {
            question: 'Are the drivers experienced for group travel?',
            answer: 'Yes, all our drivers are experienced in handling group travel. They are trained to ensure the safety and comfort of all passengers during the journey.',
          },
          {
            question: 'How do I pay for my bus service in Pune?',
            answer: 'We offer multiple payment options, including cash, credit/debit cards, and online payments via our app, making the payment process hassle-free.',
          },
          {
            question: 'Can I book a round-trip bus service in Pune?',
            answer: 'Yes, we can arrange round trips for your bus service. Just provide your return details, and we will ensure everything is taken care of for a seamless experience.',
          },
          {
            question: 'Are there any extra charges for waiting or detours?',
            answer: 'Any extra charges, such as waiting time or detours, will be communicated to you upfront to ensure complete transparency in pricing.',
          },
          {
            question: 'Can I hire a bus for sightseeing in Pune?',
            answer: 'Yes, we offer sightseeing services with our buses. Explore popular Pune attractions like Shaniwar Wada, Aga Khan Palace, and Sinhagad Fort with our experienced drivers.',
          },
          {
            question: 'What is the luggage allowance for a bus service in Pune?',
            answer: 'Our buses can accommodate standard luggage for group travel. If you have special requirements or additional luggage, please inform us during the booking process, and we’ll make the necessary arrangements.',
          },
          {
            question: 'Is S9 Travels available for corporate or event transportation in Pune?',
            answer: 'Yes, we offer corporate transportation services for meetings, seminars, or events, as well as group transport for weddings, parties, and other special occasions in Pune.',
          },
          {
            question: 'Why should I choose S9 Travels for bus services in Pune?',
            answer: 'S9 Travels guarantees a reliable, comfortable, and affordable bus service with professional drivers, well-maintained buses, and excellent customer service. We ensure a smooth and enjoyable experience for all your group travel needs in Pune.',
          },
        ]
      ];
      
      const testimonialsData = [
        {
          name: 'Mr. Aditya Verma',
          designation: 'Customer',
          rating: [1, 1, 1, 1, 1],
          text: '“We used S9 Travels for a corporate event in Pune, and the bus service was excellent. The driver was professional, the bus was comfortable, and everything went smoothly. Highly recommend!”',
        },
        {
          name: 'Mrs. Priya Joshi',
          designation: 'Customer',
          rating: [1, 1, 1, 1, 1],
          text: '“Our family hired a bus from S9 Travels for a sightseeing tour around Pune. The experience was amazing! The bus was spacious, and the driver was knowledgeable about all the tourist spots. A wonderful trip!”',
        },
      ];
      
      
      
      
      
      
      
      
      
      
    
    
    
    
    








    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 8850328441",
            "+91 9552526916",

        ],
        email: "booking@s9travels.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Book Pune To Nashik Cab",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Book Pune To Ganpatipule Cab",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Book Pune To Ratnagiri Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Book Pune To Devkund Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Book Pune To Goa Cab Taxi",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "Book Pune To Kolhapur Cab",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Book Pune To Lonavala Cab",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Book Pune To Alibaug Cab",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Book Pune To Aurangabad Cab",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Book Pune To Bhimashankar Cab",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Book Murud Janjira Cab From Pune",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Book Pune To Adlabs Imagica Cab",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Book Pune To Mahabaleshwar Cab",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Book Pune To Trimbakeshwar Cab",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Pune Mumbai Pune Round Trip",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " Mumbai Pune Pickup Drop",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Outstation Cabs From Pune",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Bus Service In Pune",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "12 Jyotirlinga Yatra From Pune",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Pune To Grishneshwar Cab Services",
        },
        
        {
            place: "/images/keyword/22.jpg",
            text: "Pune To Malshej Ghat Cab",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune To Pandharpur Cab Service",
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Pune To Panhala Fort Cab Service",
        },
        {
            place: "/images/keyword/25.jpg",
            text: " Pune To Raigad Fort Cab Service",
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Pune To Satara Kas Pathar Cab ",
        },
        {
            place: "/images/keyword/27.jpg",
            text: " Pune To Shirdi Cab Pickup Drop",
        },
    ];


    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];


    const productSchema = {
        "@context": "https://schema.org",
        "@type": "Product",
        "name": "Bus Service In Pune",
        "description": "Book bus services in Pune for local and outstation travel. Whether you need private bus hire, city sightseeing tours, school buses, or luxury buses, S9 Travels offers affordable and reliable bus rental services for all occasions in Pune.",
        "aggregateRating": {
          "@type": "AggregateRating",
          "bestRating": "5",
          "worstRating": "1",
          "ratingValue": "4.8",
          "ratingCount": "8569"
        }
      };


    return (
        <div>
          <Helmet>
        <title>Bus Service In Pune | Affordable Bus Rentals & Hire | S9 Travels</title>
        <meta 
          name="description" 
          content="Book Pune bus services for local travel, group tours, private bus hire, school buses, sightseeing, and luxury bus rentals with S9 Travels. Get the best Pune bus booking options for all your travel needs, including buses to Mumbai and other destinations." 
        />
        
        {/* Inject JSON-LD Schema */}
        <script type="application/ld+json">
          {JSON.stringify(productSchema)}
        </script>
      </Helmet>
      
      
      
<section className="page-title centred">
      <div className="bg-layer" style={{ backgroundImage: 'url(/images/background/page-title.jpg)' }}></div>
      <div className="auto-container">
        <div className="content-box">
        
          <h1>{cardData.keyword}</h1>
        </div>
      </div>
    </section>

      

            <section id="about" className="jarallax text-light">
                <div className="center-y relative text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                {/* <h1 className='text-white'>{cardData.keyword}</h1> */}
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/18.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#322E77', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                  <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For S9 Travels</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                            <FAQKeyword  faqs={faqData} />

                                                {/* <FAQKeyword faqData={faqData} /> */}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <Testimonials testimonials={testimonialsData} />
                         

                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #252E5B',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#252E5B' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+918850328441" className="d-block  text-white">+91 8850328441</a>
                                                <a href="tel:+919552526916" className="d-block  text-white">+91 9552526916</a>
                                                


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#252E5B' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Email</h4>
                                                <a href="mailto:booking@s9travels.com" className=" text-white d-block">
                                                    booking@s9travels.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#252E5B' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> S9 Travels <br/>
                                                    Khandesh Nagar, Ghandharva Nagri, Moshi,Pune, pin-412105
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Busserviceinpune;